<template>
  <div class="input">
    <label class="label">
      <input
        ref="input"
        :type="inputType"
        class="input__input"
        :placeholder="placeholder"
        :value="query"
        @input="onInput"
      />
    </label>
  </div>
</template>

<script>
/**
 * A generic input that holds
 *
 * @prop {string} value - Initial value of the field (can also use 'v-model' attr).
 * @prop {boolean} autofocus - Set to true to automatically focus this component when it mounts.
 * @prop {string} placeholder - Placeholder text to show in the input.
 * @prop {number} throttleTime - A number in milliseconds. Input events will be
 *                               throttled to only fire at this speed.
 */

export default {
  name: 'Input',
  props: {
    value: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '',
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    throttleTime: {
      type: Number,
      default: 300,
    },
    inputType: {
      type: String,
      default: 'text',
    },
  },
  data() {
    return {
      query: this.$props.value,
    }
  },
  watch: {
    value(val) {
      this.query = val
    },
    query(val) {
      window.clearTimeout(this.timeout)
      this.timeout = setTimeout(() => this.$emit('input', val), this.throttleTime)
    },
  },
  mounted() {
    if (this.autofocus) {
      this.$nextTick(() => this.$refs.input.focus())
    }
  },
  methods: {
    onInput(event) {
      this.query = event.target.value
    },
    clear() {
      this.query = ''
    },
    select() {
      this.$refs.input.select()
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../styles/variables';

.input {
  position: relative;
  display: flex;
  align-items: center;
  padding-top: 2rem;
  border-bottom: 2px solid $night-rider;

  &__input {
    width: 100%;
    padding: 1px;
    margin: 1px;
    border: none;
    bottom: 0rem;

    &::placeholder {
      color: $mid-gray;
    }

    &:focus {
      outline: none;
    }
  }
}

.label {
  width: 100%;
  display: flex;
  justify-content: baseline;
}
</style>
